import LogoComponent from '@modules/public/main/logo/LogoComponent';
import React, {ReactElement} from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {UnauthenticatedRoute} from './AuthStateRoutes';
import {PUBLIC_ROUTES, RouteInfo} from './RouteConstants';
import {BASE_ROUTE} from './BaseRoute';

const LoginPage = React.lazy(
  () => import('../modules/public/main/login/Login')
);
const SignUpPage = React.lazy(
  () => import('../modules/public/main/signUp/SignUp')
);
const VerifyUserPage = React.lazy(
  () => import('../modules/public/main/verify-user/VerifyUser')
);
const CreatePasswordPage = React.lazy(
  () => import('../modules/public/main/create-password/CreatePassword')
);
const ForgetPasswordPage = React.lazy(
  () => import('../modules/public/main/forget-password/ForgetPassword')
);
const ResetPasswordPage = React.lazy(
  () => import('../modules/public/main/reset-password/ResetPassword')
);
const EpicLaunchComponent = React.lazy(
  () => import('../modules/public/main/external-screen/EpicLaunchComponent')
);
const EpicRedirectComponent = React.lazy(
  () => import('../modules/public/main/external-screen/EpicRedirectComponent')
);
const AdaptcareLMSLaunchComponent = React.lazy(
  () => import('../modules/public/main/Adaptcarelms/AdapcareLaunchComponent')
);
const UnauthorizedScreen = React.lazy(
  () => import('../modules/public/main/unauthorized-screen/Unauthorized')
);
const CallbackScreen = React.lazy(
  () => import('../modules/public/main/callback-screen/CallbackComponent')
);

const AthenaLaunchComponent = React.lazy(
  () => import('../modules/public/main/external-screen/athena/LaunchComponent')
);
const AthenaRedirectComponent = React.lazy(
  () =>
    import('../modules/public/main/external-screen/athena/RedirectComponent')
);

export const PUBLIC_ROUTES_ARR: Array<RouteInfo> = [
  {
    route: PUBLIC_ROUTES.ROOT,
    requiresAuthCheck: true,
    Component: LoginPage,
    id: '1'
  },
  {
    route: PUBLIC_ROUTES.LOGIN,
    requiresAuthCheck: true,
    Component: LoginPage,
    id: '2'
  },
  {
    route: PUBLIC_ROUTES.SIGN_UP,
    requiresAuthCheck: true,
    Component: SignUpPage,
    id: '3'
  },
  {
    route: PUBLIC_ROUTES.VERIFY_USER,
    requiresAuthCheck: true,
    Component: VerifyUserPage,
    id: '4'
  },
  {
    route: PUBLIC_ROUTES.CREATE_PASSWORD,
    requiresAuthCheck: true,
    Component: CreatePasswordPage,
    id: '5'
  },
  {
    route: PUBLIC_ROUTES.FORGET_PASSWORD,
    requiresAuthCheck: true,
    Component: ForgetPasswordPage,
    id: '6'
  },
  {
    route: PUBLIC_ROUTES.RESET_PASSWORD,
    requiresAuthCheck: true,
    Component: ResetPasswordPage,
    id: '7'
  },
  {
    route: PUBLIC_ROUTES.EPIC,
    requiresAuthCheck: true,
    Component: EpicLaunchComponent,
    id: '8'
  },
  {
    route: PUBLIC_ROUTES.EXTERNAL,
    requiresAuthCheck: true,
    Component: EpicRedirectComponent,
    id: '9'
  },
  {
    route: PUBLIC_ROUTES.UNAUTHORIZED_USER,
    requiresAuthCheck: true,
    Component: UnauthorizedScreen,
    id: '10'
  },
  {
    route: PUBLIC_ROUTES.CALL_BACK,
    requiresAuthCheck: true,
    Component: CallbackScreen,
    id: '11'
  },

  {
    route: PUBLIC_ROUTES.LMSLAUNCHPAGE,
    requiresAuthCheck: true,
    Component: AdaptcareLMSLaunchComponent,
    id: '12'
  },
  {
    route: PUBLIC_ROUTES.ATHENA,
    requiresAuthCheck: true,
    Component: AthenaLaunchComponent,
    id: '13'
  },
  {
    route: PUBLIC_ROUTES.ATHENA_EXTERNAL,
    requiresAuthCheck: true,
    Component: AthenaRedirectComponent,
    id: '14'
  }
];

const PublicRoutes = (): ReactElement => {
  return (
    <Routes>
      {PUBLIC_ROUTES_ARR.map(routes => {
        const {Component} = routes;
        const routePath =
          routes.route === PUBLIC_ROUTES.ROOT
            ? `/${BASE_ROUTE}`
            : `/${BASE_ROUTE}/${routes.route}`;

        if (routes.route === PUBLIC_ROUTES.LOGIN) {
          return (
            <Route
              key={routes.id}
              path={routePath}
              element={
                <UnauthenticatedRoute>
                  <Component />
                </UnauthenticatedRoute>
              }
            />
          );
        } else {
          return (
            <Route
              key={routes.id}
              path={routePath}
              element={
                <>
                  {/* <div style={{padding: '0.75em 1em'}}> */}
                  <LogoComponent />
                  {/* </div> */}
                  <UnauthenticatedRoute>
                    <Component />
                  </UnauthenticatedRoute>
                </>
              }
            />
          );
        }
      })}
      <Route
        path="*"
        element={<Navigate to={`/${BASE_ROUTE}/` + PUBLIC_ROUTES.LOGIN} />}
      />
    </Routes>
  );
};

export default PublicRoutes;
